<template>
  <div>
    
    <b-button variant="outline-light" v-on:click="getOrderListDetay()">
      <Icon icon="akar-icons:search" width="25" height="25" v-b-tooltip.hover.bottom="'DETAY'" color="#28C76F" />
    </b-button>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default {
  components: {
    Icon
  },
  methods: {
    getOrderListDetay() {
      this.$root.$emit("getOrderListDetay", this.params.data);
    }
  }
};
</script>
